<div class="card w-100 shadow scss-card-margin">
    <div class="card-body preview-card">
        <ng-container *ngTemplateOutlet="chipPreviewContentTemplate; context: {$implicit: data}"></ng-container>
    </div>
</div>
